import React from 'react'
import { InputLabel } from '@material-ui/core'
import { StyledFormGroup, StyledChip } from './styled'
import { colors } from '../../styles'

export interface ILabeledChip {
  label: string
  children: string
}

export const LabeledChip = ({ label, children }: ILabeledChip) => (
  <StyledFormGroup>
    <InputLabel shrink>{label}</InputLabel>
    <div>
      <StyledChip label={children} style={{ color: colors.textDisabled }} />
    </div>
  </StyledFormGroup>
)
